<template>
    <a href="https://under-construction.club">
        <svg href="https://under-construction.club" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154.35 101.03">
            <path class="cls-1 sign-inner" d="M50.51,101a5.89,5.89,0,0,1-4.19-1.74L1.81,54.7a5.93,5.93,0,0,1,0-8.38L46.33,1.81a5.92,5.92,0,0,1,8.38,0L99.22,46.33a5.92,5.92,0,0,1,0,8.38L54.7,99.22A5.88,5.88,0,0,1,50.51,101Z" />
            <path d="M50.51.15a5.81,5.81,0,0,1,4.14,1.71L99.17,46.38a5.85,5.85,0,0,1,0,8.27L54.65,99.17a5.85,5.85,0,0,1-8.27,0L1.86,54.65a5.85,5.85,0,0,1,0-8.27L46.38,1.86A5.81,5.81,0,0,1,50.51.15m0-.15a6,6,0,0,0-4.24,1.76L1.76,46.27a6,6,0,0,0,0,8.49L46.27,99.27a6,6,0,0,0,8.49,0L99.27,54.76a6,6,0,0,0,0-8.49L54.76,1.76A6,6,0,0,0,50.51,0Z" />
            <path class="cls-1 sign-inner" d="M50.51,96.78a5.71,5.71,0,0,1-4.07-1.68L5.93,54.58a5.76,5.76,0,0,1,0-8.13L46.45,5.93a5.75,5.75,0,0,1,8.13,0L95.1,46.45a5.75,5.75,0,0,1,0,8.13L54.58,95.1A5.71,5.71,0,0,1,50.51,96.78Z" />
            <path d="M50.51,4.5A5.46,5.46,0,0,1,54.4,6.11L94.92,46.63a5.51,5.51,0,0,1,0,7.78L54.4,94.92a5.5,5.5,0,0,1-7.78,0L6.11,54.4a5.5,5.5,0,0,1,0-7.78L46.63,6.11A5.46,5.46,0,0,1,50.51,4.5m0-.5a6,6,0,0,0-4.24,1.76L5.76,46.27a6,6,0,0,0,0,8.49L46.27,95.27a6,6,0,0,0,8.49,0L95.27,54.76a6,6,0,0,0,0-8.49L54.76,5.76A6,6,0,0,0,50.51,4Z" />
            <text class="cls-2" transform="translate(15.05 57.81)">UnderCon
                <tspan class="cls-3" x="58.94" y="0">s</tspan>
                <tspan class="cls-4" x="65.16" y="0">tru</tspan>
                <tspan class="cls-5" x="81.75" y="0">c</tspan>
                <tspan x="88.5" y="0">tionClub</tspan>
            </text>
        </svg>
    </a>
</template>
<script>
export default {
    name: 'logo',
    data() {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
svg {
    cursor: pointer;
    height: 75px;
}

svg:hover {
    .sign-inner {
        fill: yellow;
    }
}

.cls-1 {
    fill: #fff;
}

.cls-2 {
    font-size: 22px;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 0.25px;
    font-family: GTAmericav2-CompressedUltraLightItalic, GT America v2;
    font-style: italic;
}

.cls-3 {
    letter-spacing: 0.01em;
}

.cls-4 {
    letter-spacing: 0em;
}

.cls-5 {
    letter-spacing: 0em;
}
</style>


// WEBPACK FOOTER //
// logo.vue?cc0d5942